import { Injectable } from '@angular/core';


export class TabsetConfig {
  /** provides default navigation context class: 'tabs' or 'pills' */
  public type: string = 'tabs';
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
